import { NotifyHelper } from "../../../helpers/toast";
import { edongBoHocPhiActionsObj } from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const dongBoHocPhiActions = {
  ...generateActions(edongBoHocPhiActionsObj, "DONG_BO_HOC_PHI"),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "SYNC_SUCCESS",
    (m) => {
      NotifyHelper.Success("Đồng bộ thành công");
    }
  ),
  ...generateActionForKey(
    edongBoHocPhiActionsObj,
    "DONG_BO_HOC_PHI",
    "SYNC_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Đồng bộ thất bại");
    }
  ),
};
